import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './workshop.css'
import SlideDeckPage from 'containers/SlideDeckPage'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/" element={<SlideDeckPage />} />
        <Route path="/deck/:id" element={<SlideDeckPage />} />
        {/* Back-compat for direct id at root */}
        <Route path=":id" element={<SlideDeckPage />} />
        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
)